if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.enctype = 'multipart/form-data';

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        const fileInput = document.getElementById('custom-image-prop');
        const textInput = document.getElementById('custom-text-prop');
        const errorMsg = document.getElementById('custom-image-error');

        const triggerBox =
          document.querySelector('.js-trigger-box') ||
          document.getElementById('upload-trigger-box');

        const uploadWrapper = document.getElementById(
          'js-custom-upload-wrapper'
        );

        const videoCheckbox = document.getElementById(
          'video-addon-checkbox'
        );

        const isVideoAddonFlow = !!videoCheckbox;

        const videoSelected =
          isVideoAddonFlow &&
          videoCheckbox.checked;

        const oldCustomizationRequired =
          !isVideoAddonFlow &&
          uploadWrapper &&
          uploadWrapper.offsetParent !== null;

        const customizationRequired =
          videoSelected ||
          oldCustomizationRequired;

        if (
          customizationRequired &&
          fileInput &&
          fileInput.files.length === 0
        ) {
          evt.stopPropagation();
          evt.stopImmediatePropagation();

          if (errorMsg) {
            errorMsg.style.display = 'flex';
          }

          if (triggerBox) {
            triggerBox.style.borderColor = '#d04343';
            triggerBox.style.backgroundColor = '#fff0f0';

            setTimeout(() => {
              triggerBox.style.backgroundColor = '#fff';
            }, 1000);
          } else {
            fileInput.style.borderColor = '#d04343';
          }

          (uploadWrapper || fileInput).scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });

          return false;
        }

        if (errorMsg) {
          errorMsg.style.display = 'none';
        }

        if (triggerBox) {
          triggerBox.style.borderColor = '#ccc';
        }

        const submitButton =
          this.querySelector('[type="submit"]');

        /*
         * 全站购物车 mutation 锁。
         *
         * 防止：
         * Add 尚未结束时又删除 / 改数量；
         * 删除尚未结束时又 Add；
         * 两个请求同时拿旧 line index。
         */
        if (
          submitButton.classList.contains('loading') ||
          window.__cloudCartMutationBusy
        ) {
          return;
        }

        window.__cloudCartMutationBusy = true;

        this.handleErrorMessage();

        submitButton.setAttribute(
          'aria-disabled',
          true
        );

        submitButton.classList.add('loading');

        const defaultText =
          submitButton.querySelector('span');

        let originalButtonText = '';

        if (defaultText) {
          originalButtonText =
            defaultText.textContent;

          defaultText.textContent =
            videoSelected
              ? 'Uploading...'
              : 'Adding...';
        }

        const spinner =
          this.querySelector(
            '.loading-overlay__spinner'
          );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        /*
         * 保留你的提前 Cart Drawer 体验。
         */
        if (videoSelected) {
          this.openCartDrawerLoading(
            'Preparing your Cloud House...'
          );
        }

        try {
          // =========================================================
          // Main Product Form
          // =========================================================

          const mainFormData =
            new FormData(this.form);

          let qtyInput =
            this.form.querySelector(
              'input[name="quantity"]'
            );

          if (
            !qtyInput &&
            this.form.id
          ) {
            qtyInput =
              document.querySelector(
                `input[name="quantity"][form="${this.form.id}"]`
              );
          }

          if (!qtyInput) {
            qtyInput =
              document.querySelector(
                'input[name="quantity"]'
              );
          }

          if (qtyInput) {
            mainFormData.set(
              'quantity',
              qtyInput.value
            );
          }

          mainFormData.delete('sections');
          mainFormData.delete('sections_url');

          /*
           * 不允许 accelerated checkout 的
           * shopify-additional-items 混进普通 ATC。
           */
          this.removeAcceleratedCheckoutFields(
            mainFormData
          );

          let finalCartResponse = null;

          // =========================================================
          // Cloud House + Video Add-on
          // =========================================================

          if (isVideoAddonFlow) {
            /*
             * Video 的资料只能属于 child。
             * 绝对不能写进 Cloud House parent。
             */
            mainFormData.delete(
              'properties[Custom Image]'
            );

            mainFormData.delete(
              'properties[Custom Text]'
            );

            mainFormData.delete(
              'shopify-additional-items[1][properties][Custom Image]'
            );

            mainFormData.delete(
              'shopify-additional-items[1][properties][Custom Text]'
            );

            if (videoSelected) {
              const videoVariantId =
                videoCheckbox.dataset
                  .addonVariantId;

              if (!videoVariantId) {
                throw new Error(
                  'Video add-on Variant ID is missing.'
                );
              }

              if (
                !fileInput ||
                !fileInput.files ||
                fileInput.files.length === 0
              ) {
                throw new Error(
                  'Please upload a pet photo for the memorial video.'
                );
              }

              const mainVariantId =
                String(
                  mainFormData.get('id') ||
                  ''
                );

              if (!mainVariantId) {
                throw new Error(
                  'Cloud House Variant ID is missing.'
                );
              }

              const mainQuantity =
                Math.max(
                  1,
                  parseInt(
                    mainFormData.get(
                      'quantity'
                    ) || '1',
                    10
                  ) || 1
                );

              /*
               * 每个 Bundle 都有唯一 ID。
               *
               * Bundle parent 必须保持独立，
               * 不能和另一个带不同 Video 的
               * Cloud House 合并。
               */
              const bundleId =
                window.crypto &&
                typeof window.crypto.randomUUID ===
                  'function'
                  ? window.crypto.randomUUID()
                  : (
                      Date.now().toString(36) +
                      '-' +
                      Math.random()
                        .toString(36)
                        .slice(2)
                    );

              /*
               * Parent + Child 一次 cart/add。
               *
               * 不再使用：
               * parent add
               * → parent_line_key
               * → child add
               */
              const bundleFormData =
                new FormData();

              // =====================================================
              // Parent: Cloud House
              // =====================================================

              bundleFormData.set(
                'items[0][id]',
                mainVariantId
              );

              bundleFormData.set(
                'items[0][quantity]',
                String(mainQuantity)
              );

              bundleFormData.set(
                'items[0][properties][_Cloud Bundle ID]',
                bundleId
              );

              // =====================================================
              // Child: Video
              // =====================================================

              bundleFormData.set(
                'items[1][id]',
                String(videoVariantId)
              );

              bundleFormData.set(
                'items[1][quantity]',
                '1'
              );

              bundleFormData.set(
                'items[1][parent_id]',
                mainVariantId
              );

              bundleFormData.set(
                'items[1][properties][_Cloud Bundle ID]',
                bundleId
              );

              bundleFormData.set(
                'items[1][properties][Custom Image]',
                fileInput.files[0]
              );

              if (
                textInput &&
                textInput.value.trim()
              ) {
                bundleFormData.set(
                  'items[1][properties][Custom Text]',
                  textInput.value.trim()
                );
              }

              /*
               * 保留第二段 Loading。
               */
              this.updateCartDrawerLoading(
                'Uploading your pet photo...'
              );

              /*
               * 只发生一次 Add。
               * 同一次返回 Drawer sections。
               */
              const addedBundle =
                await this.addFormDataToCart(
                  bundleFormData,
                  true
                );

              // =====================================================
              // Verify nested relationship
              // =====================================================

              const responseItems =
                addedBundle &&
                Array.isArray(
                  addedBundle.items
                )
                  ? addedBundle.items
                  : [];

              const addedParent =
                responseItems.find(
                  (item) => {
                    const itemVariantId =
                      String(
                        item.variant_id ||
                        item.id ||
                        ''
                      );

                    return (
                      itemVariantId ===
                        mainVariantId &&

                      item.properties &&

                      item.properties[
                        '_Cloud Bundle ID'
                      ] === bundleId
                    );
                  }
                );

              const addedVideo =
                responseItems.find(
                  (item) => {
                    const itemVariantId =
                      String(
                        item.variant_id ||
                        item.id ||
                        ''
                      );

                    return (
                      itemVariantId ===
                        String(
                          videoVariantId
                        ) &&

                      item.properties &&

                      item.properties[
                        '_Cloud Bundle ID'
                      ] === bundleId
                    );
                  }
                );

              const nestedCorrectly =
                !!(
                  addedParent &&
                  addedVideo &&

                  addedVideo
                    .parent_relationship &&

                  addedVideo
                    .parent_relationship
                    .parent_key &&

                  addedVideo
                    .parent_relationship
                    .parent_key ===
                    addedParent.key
                );

              if (!nestedCorrectly) {
                console.error(
                  'Cloud House bundle verification failed:',
                  {
                    bundleId,
                    addedBundle,
                  }
                );

                throw new Error(
                  'The Cloud House and memorial video could not be linked correctly.'
                );
              }

              finalCartResponse =
                addedBundle;
            } else {
              // =====================================================
              // Cloud House only
              // =====================================================

              /*
               * 普通 Cloud House：
               *
               * 不写 _Cloud Bundle ID
               * 不写 _Cloud Line ID
               *
               * 同 SKU 的普通 Cloud House
               * 交给 Shopify 正常合并 quantity。
               *
               * 注意必须 includeSections = true，
               * 否则之前会进入 Drawer fallback，
               * 造成随机跳 /cart。
               */
              finalCartResponse =
                await this.addFormDataToCart(
                  mainFormData,
                  true
                );
            }
          } else {
            // =======================================================
            // Other old custom products
            // =======================================================

            if (
              fileInput &&
              fileInput.files.length > 0 &&
              !mainFormData.has(
                'properties[Custom Image]'
              )
            ) {
              mainFormData.append(
                'properties[Custom Image]',
                fileInput.files[0]
              );
            }

            if (
              textInput &&
              textInput.value &&
              !mainFormData.has(
                'properties[Custom Text]'
              )
            ) {
              mainFormData.append(
                'properties[Custom Text]',
                textInput.value
              );
            }

            finalCartResponse =
              await this.addFormDataToCart(
                mainFormData,
                true
              );
          }

          await this.renderCartResponse(
            finalCartResponse
          );
        } catch (e) {
          console.error(e);

          this.closeCartDrawerLoading();

          this.handleErrorMessage(
            e.message ||
              'Unable to add item to cart.'
          );

          alert(
            'Error: ' +
              (
                e.message ||
                'Unable to add item to cart.'
              )
          );
        } finally {
          window.__cloudCartMutationBusy =
            false;

          submitButton.classList.remove(
            'loading'
          );

          if (spinner) {
            spinner.classList.add(
              'hidden'
            );
          }

          submitButton.removeAttribute(
            'aria-disabled'
          );

          if (
            defaultText &&
            originalButtonText
          ) {
            defaultText.textContent =
              originalButtonText;
          }
        }
      }

      // =============================================================
      // Remove accelerated checkout fields
      // =============================================================

      removeAcceleratedCheckoutFields(
        formData
      ) {
        const keys = [];

        for (
          const key of formData.keys()
        ) {
          if (
            String(key).startsWith(
              'shopify-additional-items['
            )
          ) {
            keys.push(key);
          }
        }

        keys.forEach((key) => {
          formData.delete(key);
        });
      }

      // =============================================================
      // Add item to Shopify
      // =============================================================

      async addFormDataToCart(
        formData,
        includeSections = false
      ) {
        formData.delete('sections');
        formData.delete('sections_url');

        if (
          includeSections &&
          this.cart &&
          typeof this.cart
            .getSectionsToRender ===
            'function'
        ) {
          const sections =
            this.cart
              .getSectionsToRender()
              .map(
                (section) =>
                  section.id
              );

          if (sections.length > 0) {
            formData.append(
              'sections',
              sections
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );
          }

          if (
            typeof this.cart
              .setActiveElement ===
              'function'
          ) {
            this.cart.setActiveElement(
              document.activeElement
            );
          }
        }

        const config =
          fetchConfig('javascript');

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        /*
         * FormData + File 时不能手动写
         * multipart Content-Type。
         */
        delete config.headers[
          'Content-Type'
        ];

        config.body =
          formData;

        const response =
          await fetch(
            `${routes.cart_add_url}`,
            config
          );

        const rawText =
          await response.text();

        let data = null;

        try {
          data =
            JSON.parse(rawText);
        } catch (e) {}

        if (!response.ok) {
          const errorMessage =
            (
              data &&
              (
                data.description ||
                data.message
              )
            ) ||
            rawText ||
            `Add failed (HTTP ${response.status})`;

          console.error(
            'Shopify cart/add failed:',
            {
              status:
                response.status,
              rawText,
              data,
            }
          );

          throw new Error(
            errorMessage
          );
        }

        if (!data) {
          throw new Error(
            'Shopify returned an invalid cart response.'
          );
        }

        if (data.status) {
          throw new Error(
            data.description ||
              data.message ||
              'Unable to add item to cart.'
          );
        }

        return data;
      }

      // =============================================================
      // Render Cart Drawer
      // =============================================================

      async renderCartResponse(
        cartResponse
      ) {
        /*
         * Section render 可能替换 DOM，
         * 所以每次重新拿当前 drawer 节点。
         */
        this.cart =
          document.querySelector(
            'cart-notification'
          ) ||
          document.querySelector(
            'cart-drawer'
          ) ||
          this.cart;

        if (
          this.cart &&
          cartResponse &&
          cartResponse.sections &&
          typeof this.cart
            .renderContents ===
            'function'
        ) {
          this.cart.classList.remove(
            'is-empty'
          );

          this.cart.renderContents(
            cartResponse
          );

          return;
        }

        /*
         * 这里只 fallback 刷新 Drawer。
         *
         * 绝对不再：
         * window.location = /cart
         */
        await this
          .refreshCartDrawerFallback();
      }

      // =============================================================
      // Drawer fallback
      // =============================================================

      async refreshCartDrawerFallback() {
        const response =
          await fetch(
            `${routes.cart_url}?section_id=cart-drawer`
          );

        if (!response.ok) {
          throw new Error(
            'Cart was updated, but the cart drawer could not be refreshed.'
          );
        }

        const responseText =
          await response.text();

        const parser =
          new DOMParser();

        const doc =
          parser.parseFromString(
            responseText,
            'text/html'
          );

        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );

        const targetContent =
          document.querySelector(
            '#CartDrawer'
          );

        const sourceContent =
          doc.querySelector(
            '#CartDrawer'
          );

        if (
          cartDrawer &&
          targetContent &&
          sourceContent
        ) {
          cartDrawer.classList.remove(
            'is-empty'
          );

          targetContent.innerHTML =
            sourceContent.innerHTML;

          const cartBubble =
            document.getElementById(
              'cart-icon-bubble'
            );

          const newCartBubble =
            doc.getElementById(
              'cart-icon-bubble'
            );

          if (
            cartBubble &&
            newCartBubble
          ) {
            cartBubble.innerHTML =
              newCartBubble.innerHTML;
          }

          if (
            typeof cartDrawer.open ===
              'function'
          ) {
            cartDrawer.open();
          } else {
            cartDrawer.classList.add(
              'active',
              'animate'
            );

            const summary =
              cartDrawer.querySelector(
                'summary'
              );

            if (summary) {
              summary.click();
            }
          }

          return;
        }

        throw new Error(
          'Cart was updated, but the cart drawer markup could not be found.'
        );
      }

      // =============================================================
      // Instant Cart Drawer Loading UI
      // =============================================================

      openCartDrawerLoading(
        message =
          'Preparing your Cloud House...'
      ) {
        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );

        if (!cartDrawer) {
          return;
        }

        if (
          !document.getElementById(
            'cloud-cart-loading-style'
          )
        ) {
          const style =
            document.createElement(
              'style'
            );

          style.id =
            'cloud-cart-loading-style';

          style.textContent = `
            @keyframes cloudCartSpin {
              to {
                transform: rotate(360deg);
              }
            }

            .cloud-cart-loading-overlay {
              position: absolute;
              inset: 0;
              z-index: 1000;

              display: flex;
              align-items: center;
              justify-content: center;

              padding: 32px;

              background:
                rgb(var(--color-background));

              color:
                rgb(var(--color-foreground));

              text-align: center;

              pointer-events: all;
            }

            .cloud-cart-loading-content {
              display: flex;
              flex-direction: column;
              align-items: center;

              max-width: 300px;
            }

            .cloud-cart-loading-spinner {
              width: 28px;
              height: 28px;

              margin-bottom: 18px;

              border: 2px solid
                rgba(var(--color-foreground), .18);

              border-top-color:
                rgb(var(--color-foreground));

              border-radius: 50%;

              animation:
                cloudCartSpin .75s linear infinite;
            }

            .cloud-cart-loading-title {
              margin: 0;

              font-size: 16px;
              line-height: 1.4;
              font-weight: 600;

              color:
                rgb(var(--color-foreground));
            }

            .cloud-cart-loading-note {
              margin: 7px 0 0;

              font-size: 12px;
              line-height: 1.45;

              color:
                rgba(var(--color-foreground), .58);
            }
          `;

          document.head.appendChild(
            style
          );
        }

        if (
          typeof cartDrawer
            .setActiveElement ===
            'function'
        ) {
          cartDrawer.setActiveElement(
            document.activeElement
          );
        }

        cartDrawer.classList.remove(
          'is-empty'
        );

        if (
          typeof cartDrawer.open ===
            'function'
        ) {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add(
            'active',
            'animate'
          );
        }

        requestAnimationFrame(() => {
          const drawerInner =
            cartDrawer.querySelector(
              '.drawer__inner'
            ) ||
            cartDrawer.querySelector(
              '#CartDrawer'
            );

          if (!drawerInner) {
            return;
          }

          const position =
            window.getComputedStyle(
              drawerInner
            ).position;

          if (position === 'static') {
            drawerInner.style.position =
              'relative';
          }

          let overlay =
            drawerInner.querySelector(
              '.cloud-cart-loading-overlay'
            );

          if (!overlay) {
            overlay =
              document.createElement(
                'div'
              );

            overlay.className =
              'cloud-cart-loading-overlay';

            overlay.setAttribute(
              'data-cloud-cart-loading',
              ''
            );

            overlay.innerHTML = `
              <div class="cloud-cart-loading-content">
                <div
                  class="cloud-cart-loading-spinner"
                  aria-hidden="true"
                ></div>

                <p
                  class="cloud-cart-loading-title"
                  data-cloud-cart-loading-message
                ></p>

                <p
                  class="cloud-cart-loading-note"
                >
                  Please keep this page open.
                </p>
              </div>
            `;

            drawerInner.appendChild(
              overlay
            );
          }

          const messageElement =
            overlay.querySelector(
              '[data-cloud-cart-loading-message]'
            );

          if (messageElement) {
            messageElement.textContent =
              message;
          }
        });
      }

      updateCartDrawerLoading(
        message
      ) {
        const messageElement =
          document.querySelector(
            '[data-cloud-cart-loading-message]'
          );

        if (messageElement) {
          messageElement.textContent =
            message;
        }
      }

      removeCartDrawerLoading() {
        document
          .querySelectorAll(
            '[data-cloud-cart-loading]'
          )
          .forEach((element) => {
            element.remove();
          });
      }

      closeCartDrawerLoading() {
        this.removeCartDrawerLoading();

        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );

        if (
          cartDrawer &&
          typeof cartDrawer.close ===
            'function'
        ) {
          cartDrawer.close();
        }
      }

      // =============================================================
      // Error message
      // =============================================================

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper
            .querySelector(
              '.product-form__error-message'
            );

        this.errorMessageWrapper
          .toggleAttribute(
            'hidden',
            !errorMessage
          );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      // =============================================================
      // Submit button
      // =============================================================

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton
            .setAttribute(
              'disabled',
              'disabled'
            );

          if (text) {
            this.submitButtonText
              .textContent =
              text;
          }
        } else {
          this.submitButton
            .removeAttribute(
              'disabled'
            );

          this.submitButtonText
            .textContent =
            window.variantStrings
              .addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}